import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExtensionUninstalledPage = loadAsyncComponent(() => import('./Container'), 'page');
